import merge from 'lodash/merge';
import {
  GET_PLANS_SUCCESS,
  UPDATE_CANCELLATION_META_SUCCESS,
} from '../actions';

const initialState = [];

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PLANS_SUCCESS:
      return payload;
    case UPDATE_CANCELLATION_META_SUCCESS: {
      const { planId, ...meta } = payload;

      return state.map(plan =>
        plan.id !== planId ? plan : merge({}, plan, { PlanCancellation: meta }),
      );
    }
    default:
      return state;
  }
};
